import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useModalData } from "../Modal/useModalData";
import Form, { FORM_HORIZONTAL_LAYOUT } from "../Form";
import useFormSubmit from "../Form/useFormSubmit";
import { closeModalAction } from "../Modal/reducer";
import Button from "../Button";
import { renderDynamicallyFields } from "../Form/methods";
import { openNotification } from "../Notification";
import axios from "../../axios";
import { FORM_ITEM_RESOURCE_SELECT } from "../Form/FormItems/FormItemResourceSelect";

const ShareCompaniesForm = ({ modalName, apiRoute, idKey, titleKey, descriptionKey, onSuccessAction }) => {
  const data = useModalData(modalName);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading, submit, generalError } = useFormSubmit({
    form,
    route: apiRoute,
    transformer: (values) => ({ shared_companies: values.shared_companies || [], [idKey]: data.id }),
    onSuccess: () => {
      dispatch(closeModalAction({ name: modalName }));
      onSuccessAction(dispatch);
    },
    onFailed: (err) => {
      openNotification({
        type: "error",
        message: t(
          err?.response?.status === 422 ? "qam.invalid_shared_companies" : "container.form_errors.internal_server_error"
        )
      });
    }
  });

  const domain = globalThis.location.hostname.split(".").slice(1).join(".");
  const [options, setOptions] = React.useState(
    data.shared_companies?.map((item) => ({
      id: item.id,
      value: item.id,
      label: `${item.name} (${item.slug}.${domain})`
    })) || []
  );

  useEffect(() => {
    axios.get("get-linked-companies?order_by_column%5B%5D=name&order_by_type%5B%5D=asc").then((res) => {
      const formatted = res.data.data.map((item) => ({
        id: item.id,
        value: item.id,
        label: `${item.name} (${item.slug}.${domain})`
      }));
      setOptions(formatted);
    });
  }, [domain]);

  return (
    <Form
      onSubmit={submit}
      form={form}
      errors={generalError}
      loading={loading}
      initialValues={{
        shared_companies: data.shared_companies?.map((item) => item.id) || []
      }}
      layout={FORM_HORIZONTAL_LAYOUT}
      header={
        <>
          <div className="h3">{t(titleKey)}</div>
          <div className="mb-30 mt-10 h6 font-weight-300 text-muted" style={{ whiteSpace: "pre-wrap" }}>
            {t(descriptionKey)}
          </div>
        </>
      }
    >
      {renderDynamicallyFields([
        {
          type: FORM_ITEM_RESOURCE_SELECT,
          name: "shared_companies",
          label: "qam.share_with",
          placeholder: "qam.select_companies",
          fieldProps: {
            mode: "multiple",
            options: options,
            fieldNames: { label: "label", value: "id" },
            optionFilterProp: "label"
          }
        }
      ])}
      <div className="flex mt-25 flex-justify-end">
        <Button
          className="min-w-150"
          type="primary"
          htmlType="submit"
          disabled={loading}
          loading={loading}
          icon={<i className="ti-check" />}
        >
          {t("container.general_words.save")}
        </Button>
      </div>
    </Form>
  );
};

export default ShareCompaniesForm;
